var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: _vm.titulo } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.model_serienumero.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: _vm.detalle
                },
                on: {
                  change: function($event) {
                    return _vm.buscar_serie_numero()
                  },
                  input: function($event) {
                    return _vm.enviar_equipo()
                  }
                },
                model: {
                  value: _vm.formFields.model_serienumero.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.model_serienumero, "value", $$v)
                  },
                  expression: "formFields.model_serienumero.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      "item-text": "tipoeqname",
                      items: _vm.lista_tipoeqname,
                      "item-value": "tipoeqid",
                      label: _vm.formFields.model_tipoeqname.label,
                      "prepend-icon": "home_repair_service",
                      disabled: _vm.detalle
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_equipo_activa()
                      }
                    },
                    model: {
                      value: _vm.formFields.model_tipoeqname.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.model_tipoeqname, "value", $$v)
                      },
                      expression: "formFields.model_tipoeqname.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      "item-text": "tipoeqname",
                      items: _vm.lista_tipoeqname,
                      "item-value": "tipoeqid",
                      label: _vm.formFields.model_tipoeqname.label,
                      "prepend-icon": "home_repair_service",
                      disabled: _vm.detalle
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_equipo_activa()
                      }
                    },
                    model: {
                      value: _vm.formFields.model_tipoeqname.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.model_tipoeqname, "value", $$v)
                      },
                      expression: "formFields.model_tipoeqname.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serie_activa_numero.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serie_activa_numero.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.serie_activa_numero, "value", $$v)
                  },
                  expression: "formFields.serie_activa_numero.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serie_activa_modalidad.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serie_activa_modalidad.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serie_activa_modalidad,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serie_activa_modalidad.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serie_activa_plataforma.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serie_activa_plataforma.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serie_activa_plataforma,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serie_activa_plataforma.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-checkbox", {
                attrs: {
                  label: _vm.formFields.serieactivaplata_ingresada.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaplata_ingresada.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivaplata_ingresada,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivaplata_ingresada.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaplata_fecha.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaplata_fecha.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivaplata_fecha,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivaplata_fecha.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaid_dispositivo.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaid_dispositivo.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivaid_dispositivo,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivaid_dispositivo.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaepc.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaepc.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.serieactivaepc, "value", $$v)
                  },
                  expression: "formFields.serieactivaepc.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.sim_serie_numero.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.sim_serie_numero.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.sim_serie_numero, "value", $$v)
                  },
                  expression: "formFields.sim_serie_numero.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.sim_estado.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.sim_estado.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.sim_estado, "value", $$v)
                  },
                  expression: "formFields.sim_estado.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.patente.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.patente.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.patente, "value", $$v)
                  },
                  expression: "formFields.patente.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.nombre_flota.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.nombre_flota.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.nombre_flota, "value", $$v)
                  },
                  expression: "formFields.nombre_flota.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.clienterut.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.clienterut.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.clienterut, "value", $$v)
                  },
                  expression: "formFields.clienterut.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.nombrecliente.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.nombrecliente.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.nombrecliente, "value", $$v)
                  },
                  expression: "formFields.nombrecliente.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivafecha_baja.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivafecha_baja.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.serieactivafecha_baja, "value", $$v)
                  },
                  expression: "formFields.serieactivafecha_baja.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaobs.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaobs.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.serieactivaobs, "value", $$v)
                  },
                  expression: "formFields.serieactivaobs.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }